
// Try Singleton
// https://anasshekhamis.com/2017/07/27/the-singleton-design-pattern-es5-and-es2015/

const uniq = Math.round(Math.random() * 10000);
const aFilesLoaded = []
let _cbkAllFilesLoaded

/**
 * NOTE: An ES6 module is a Singleton
 * @param {*} cbkAllFilesLoaded
 */
var LoaderUtils = function(cbkAllFilesLoaded) {

  // console.log(`/// LoaderUtils `, uniq);

  if (cbkAllFilesLoaded) {
    _cbkAllFilesLoaded = cbkAllFilesLoaded
  }

  if (!cbkAllFilesLoaded && !_cbkAllFilesLoaded) {
    console.log(`🕐 LoaderUtils ${uniq}, you must pass a method as callback`);
    return;
  }

  /**
   * You need to add every files before calling the loaded method below
   * @param {*} id
   */
  function add(id) {
    aFilesLoaded[id] = false
    console.log(`🕐 LoaderUtils ${uniq} add - ${id}`, aFilesLoaded)
  }

  /**
   * Then for each files loaded you need to call this method
   * @param {*} id
   */
  function loaded(id) {
    aFilesLoaded[id] = true
    console.info(`🕐 LoaderUtils ${uniq} loaded - ${id}`, Object.keys(aFilesLoaded).length)

    if (window.DEBUG_SKIP_LOADER) {
      console.log(`🕐 Skip LoaderUtils ${uniq} loaded all files !`, aFilesLoaded)
      _cbkAllFilesLoaded()
    } else {
      for (let o in aFilesLoaded) {
        // console.log(`aFilesLoaded[${o}]`, aFilesLoaded[o]);
        if (!aFilesLoaded[o]) {
          console.log(`🕐 LoaderUtils ${uniq} - ${o} not loaded...`);
          return false;
        }
      }
      // if goes here all files are loaded
      console.log(`🕐 LoaderUtils ${uniq} loaded all files !`, aFilesLoaded)
      _cbkAllFilesLoaded()
    }
  }

  return {
    add,
    loaded
  };
}

export { LoaderUtils as default }
